import { Routes } from '@angular/router'

export const ROUTES: Routes = [
  {
    path: '',
    loadChildren: './+admin#AdminModule'
  }
]
